import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import Grid2 from "@mui/material/Grid2";
import { createStyles, makeStyles } from "@mui/styles";
import type { EditableCallbackParams } from "ag-grid-community";

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			"& .ag-icon-menu": {
				display: "none",
			},
			"& .ag-checkbox-input-wrapper": {
				margin: "0 10px",
			},
			"& .ag-cell": {
				alignItems: "center",
				padding: "0 !important",
				backgroundColor: "#FFFF !important",
				border: "unset !important",
			},
			"& .ag-header-cell": {
				padding: "0px !important",
				textAlign: "center !important",
				fontSize: 10,
			},
			"& .ag-root-wrapper": {
				minHeight: "100% !important",
				borderRadius: 3,
				paddingBottom: 45,
			},
			"& .ag-cell-wrapper": {
				width: "95%",
				textAlign: "center",
			},
			"& .ag-body-viewport": {
				borderBottom: "2px solid #DDE2EB",
			},
			"& .ag-menu-option": {
				cursor: "pointer",
			},
		},
	}),
);

type Props = EditableCallbackParams;

export const DocumentTitleColumn = ({ data }: Props) => {
	const classes = useStyles();
	const {
		state: { dataDocumentSelected },
	} = useAssetDetailsContext();

	if (data.id === -1) {
		return (
			<Grid2
				container
				className={classes.root}
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 style={{ alignItems: "center", justifyContent: "center" }}>
					{dataDocumentSelected?.Title}
				</Grid2>
			</Grid2>
		);
	} else if (data.id !== -1) {
		return <>{data?.Title}</>;
	} else return <></>;
};
